/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".float-container[_ngcontent-%COMP%]{width:400px;height:265px}.float-header[_ngcontent-%COMP%]{padding:20px 0}.layer-item[_ngcontent-%COMP%]{font-weight:700;font-size:calc(var(--font-size-default) + 1px)}.layer-control-header[_ngcontent-%COMP%]{margin-bottom:12px}.layer-control-content[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:5px}\n/*# sourceMappingURL=feat-layer-control.component.css.map*/"];
export { styles as styles };
